var map = {
	"./Austropotamobius torrentium.jpg": 599,
	"./Barbus balcanicus.jpg": 239,
	"./Cobitis elongatoides.jpg": 402,
	"./Eresus kollari.jpg": 362,
	"./Ichthyosaura alpestris.jpg": 662,
	"./Lanius collurio.jpg": 378,
	"./Motacilla alba.jpg": 61,
	"./Philaeus chrysops.jpg": 803,
	"./Potamophylax coronavirus.jpg": 626,
	"./Potamophylax kosovaensis.jpg": 884,
	"./Rhinolophus hipposideros.jpg": 39,
	"./Rosalia alpina.jpg": 473,
	"./Salmo trutta.jpg": 743,
	"./Testudo hermanni.jpg": 321,
	"./Zamenis situla.jpg": 695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;